import { TypographyProps } from "ds/components/Typography";

export const DEFAULT_TITLE_VARIANT: TypographyProps["variant"] = "p-t6";
